export class EmployeeUsers {

    Id: number = 0;
    EmployeeCode: string = '';
    UserName: string = '';
    Password: string = '';
    IsActive: boolean = true;
    IsAccessMobileApp: boolean = false;
    LastLogin: string = '';
    CreatedBy: number = 0;
    CreatedOn: string = '';
    UpdatedBy: number = 0;
    UpdatedOn: string = '';
    ModuleIDs: string = '';
}
